// Steps rendered inside the shared login/signup modal, audience-agnostic: a
// retailer and a brand user hit the exact same screens (single auth guard,
// single /password/reset, single email + verification-code entry). String
// values are unchanged from their former RetailerFormType members so URLs and
// ?step tokens keep working. The retailer wizard lives in RetailerFormType (its
// own page) and the brand flow in BrandFormType (its own page).
export enum AuthFormType {
  Login = 'login',
  ResetPassword = 'reset-password',
  TwoFactor = 'two-factor',
  TwoFactorRecovery = 'two-factor-recovery',
  ResetPasswordInput = 'reset-password-input',
  EmailOnlySignUp = 'email-only-signup',
  EmailValidation = 'email-validation',
}
